import { Card } from 'components';
import { TaxonRow } from './TaxonRow';
import { AssociatedSubheading } from './AssociatedSubheading';
import { ConditionTaxa } from 'services/conditions/conditionsTaxa';
import { ConditionAssociation } from 'types/Conditions';

export const AssociatedTaxaList = ({
  taxa,
  condition,
  association,
}: {
  taxa: ConditionTaxa[];
  condition: string;
  association: ConditionAssociation;
}) => {
  const getAssociatedTaxa = (association: ConditionAssociation) =>
    taxa.filter(
      taxon =>
        taxon.condition_id === Number(condition) &&
        taxon.association === association,
    );
  const associatedTaxa = getAssociatedTaxa(association);

  return (
    <div key={association + ' ' + condition}>
      {!!associatedTaxa.length && (
        <Card title={<AssociatedSubheading association={association} />}>
          {associatedTaxa.map((taxon, index) => (
            <TaxonRow
              key={
                taxon.id +
                ' ' +
                taxon.user_abundance +
                ' ' +
                condition +
                ' ' +
                association
              }
              taxon={taxon}
              row={index}
            />
          ))}
        </Card>
      )}
    </div>
  );
};
